import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import Seo from '../../../../components/Misc/Seo';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/opg-sim/OPG_Slider.jpg';
import projectImage2 from '../../../../assets/images/work/opg-sim/OPG_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/opg-sim/OPG_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/opg-sim/OPG_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/opg-sim/OPG_Slider_5.jpg';
import projectImage6 from '../../../../assets/images/work/opg-sim/OPG_Slider_6.jpg';
import projectImage7 from '../../../../assets/images/work/opg-sim/OPG_Slider_7.jpg';

import Data_OPGIncidentCommand from './Data_OPGIncidentCommand';

function Work_OPGIncidentCommand() {
    const canonical = 'https://studio.norcat.org/OurWork/opg-sim';
    const title = 'OPG Incident Command | Studio NORCAT - Driven by experiences that matter.';
    const description = 'Developed by Studio NORCAT, OPG Incident Command is a simulation tool that helps teams practise emergency response, command decisions, and coordinated leadership before real incidents occur.';

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${projectImage1}`}
                ogImageAlt="Preview of the OPG Incident Command simulation project"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${projectImage1}`}
                twitterImageAlt="Preview of the OPG Incident Command simulation project"
            />
            <DetailedHeader
                heading="Leading the Response Before It's Real"
                client="Ontario Power Generation"
                service="Simulation Tool"
                date="2025-Present"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                useButtonNav="true"
                images={[
                    {
                        image: projectImage1,
                        alt: 'OPG Incident Command project screenshot 1',
                    },
                    {
                        image: projectImage2,
                        alt: 'OPG Incident Command project screenshot 2',
                    },
                    {
                        image: projectImage3,
                        alt: 'OPG Incident Command project screenshot 3',
                    },
                    {
                        image: projectImage4,
                        alt: 'OPG Incident Command project screenshot 4',
                    },
                    {
                        image: projectImage5,
                        alt: 'OPG Incident Command project screenshot 5',
                    },
                    {
                        image: projectImage6,
                        alt: 'OPG Incident Command project screenshot 6',
                    },
                    {
                        image: projectImage7,
                        alt: 'OPG Incident Command project screenshot 7',
                    },
                ]}
            />

            {Data_OPGIncidentCommand.content}
        </>
    );
}

export default Work_OPGIncidentCommand;
